import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const WeCouldNotFindYou: React.FC = () => {
  const navigate = useNavigate();
  const handleCheckInClick = () => {
    navigate(`/checkin/${companyIdParam}/${regionIdParam}/${locationIdParam}`); // Navigate to the test screen
  };

  // this will run everytime the component is rendered
  useEffect(() => {
    /* local‑storage clean‑up + redirect */
    [
      `checkedIn-${locationIdParam}`,
      `locationId-${locationIdParam}`,
      `outOfDate-${locationIdParam}`,
      `traineeData-${locationIdParam}`,
      `companyData-${locationIdParam}`,
    ].forEach((key) => localStorage.removeItem(key));
  }, []);

  const {
    companyId: companyIdParam = '',
    regionId: regionIdParam = '',
    locationId: locationIdParam = '',
  } = useParams<{ companyId: string; regionId: string; locationId: string }>();

  return (
    <div className="tervuren-container__column-center bg-primary mh-100 flex-gap-1">
      <div className="tervuren-container__column-center-75">
        <i className="trainee-profile-icon mb-2 mt-1" style={{ color: '#D25F5E' }} />
        <h1>Visitor Not Found</h1>
        <p className="mb-2 text-center">
          Please visit the ScaleHouse to register for Site-Specific Hazard
          Awareness Safety Training.
        </p>
        <button
          className="tervuren-button-primary"
          onClick={handleCheckInClick}
        >
          Return to Check-in
        </button>
      </div>
    </div>
  );
};

export default WeCouldNotFindYou;
